// extracted by mini-css-extract-plugin
export default {"wrapper":"NetworkingList_wrapper__ZSkq+","danger":"NetworkingList_danger__lQIfN"};